/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Search_CustomerInputs */

const en_orders_search_customer = /** @type {(inputs: Orders_Search_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search customer...`)
};

const es_orders_search_customer = /** @type {(inputs: Orders_Search_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar cliente...`)
};

/**
* | output |
* | --- |
* | "Search customer..." |
*
* @param {Orders_Search_CustomerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_search_customer = /** @type {((inputs?: Orders_Search_CustomerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Search_CustomerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_search_customer(inputs)
	return es_orders_search_customer(inputs)
});